import { Component, signal } from '@angular/core';
import { WebhookFormComponent } from "@app/components/forms/webhook/form.component";
import { WebhookHelperService } from '@app/services/helpers/webhook-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { WebhookCreate } from '@app/models/webhook.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-webhook-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        WebhookFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class WebhookCreatePage {
  public title = 'New Webhook';
  formValid = signal(false);
  formValue = signal<WebhookCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private webhookService: WebhookHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.webhookService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/webhooks/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
